import { AddDeviceInput, AddServiceInput, ModelType } from "../../API";
import {
  ServiceTypeEnum,
  configurationParametersByModelType,
} from "../../pages/model-manager/variables/modelManager";

type ParsedTemplate = {
  model: string[];
};

const MODEL_TO_SERVICE_TYPE: Record<ModelType, ServiceTypeEnum> = {
  [ModelType.gasleak]: ServiceTypeEnum.GAS_LEAK,
  [ModelType.liquidleak]: ServiceTypeEnum.LIQUID_LEAK,
  [ModelType.hardhat]: ServiceTypeEnum.HARD_HAT,
  [ModelType.agg]: ServiceTypeEnum.GATE_GUARD,
  [ModelType.tlm]: ServiceTypeEnum.TANK_LEVEL,
  [ModelType.fire]: ServiceTypeEnum.FIRE,
  [ModelType.smoke]: ServiceTypeEnum.SMOKE,
  [ModelType.firesmoke]: ServiceTypeEnum.FIRE_SMOKE,
};

const DOCKER_IMAGE_MODEL_MAP: Record<string, string> = {
  agg: "gateguard",
  tlm: "tanklevel",
};

export const mapTemplateDataToServiceInput = (
  devices: AddDeviceInput[],
  parsedTemplateData: ParsedTemplate[]
): AddServiceInput[] => {
  const serviceInputs: AddServiceInput[] = [];

  devices.forEach((device, index) => {
    const template = parsedTemplateData[index];

    template.model.forEach(modelTypeRaw => {
      const modelType = modelTypeRaw.toLowerCase() as ModelType;

      const serviceType = MODEL_TO_SERVICE_TYPE[modelType];

      if (!serviceType) {
        throw new Error(`Unknown model type: "${modelTypeRaw}"`);
      }

      const dockerImageModel = DOCKER_IMAGE_MODEL_MAP[modelType] || modelType;

      const baseConfiguration = (configurationParametersByModelType[
        modelType
      ] ?? {}) as Record<string, unknown>;

      const fullConfiguration = {
        docker_image: `534256877503.dkr.ecr.us-east-1.amazonaws.com/ccai-${dockerImageModel}:latest`,
        ...baseConfiguration,
      };

      serviceInputs.push({
        serviceType,
        nodeId: device.nodeId,
        deviceId: `DE#${device.name}`,
        locationId: device.locationId,
        customerId: device.customerId,
        configuration: JSON.stringify(fullConfiguration),
      });
    });
  });

  return serviceInputs;
};
